import { artists } from "@/assets/artists";

export const images = [
  {
      largeURL: require("@/assets/img/sfw/01.png"), 
      thumbnailURL: require("@/assets/thumbnails/sfw/t01.jpg"), 
      width: 2740,
      height: 3001,
      artist: artists.paululuh,
      creationDate: "2023-03-29",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/02.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t02.jpg"),
      width: 5528,
      height: 4776,
      artist: artists.mespeth,
      creationDate: "2023-08-24",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/03.jpg"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t03.jpg"),
      width: 1863,
      height: 1941,
      artist: artists.akuva,
      creationDate: "2023-10-22",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/04.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t04.jpg"),
      width: 755,
      height: 755,
      artist: artists.mespeth,
      creationDate: "2023-10-23",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/05.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t05.jpg"),
      width: 755,
      height: 755,
      artist: artists.mespeth,
      creationDate: "2023-10-23",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/06.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t06.jpg"),
      width: 2000,
      height: 2000,
      artist: artists.gabrianne,
      creationDate: "2023-12-27",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/07.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t07.jpg"),
      width: 1996,
      height: 1803,
      artist: artists.aprion,
      creationDate: "2024-01-07",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/08.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t08.jpg"),
      width: 3600,
      height: 4000,
      artist: artists.gabrianne,
      creationDate: "2024-01-09",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/09.jpg"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t09.jpg"),
      width: 1700,
      height: 1600,
      artist: artists.gabrianne,
      creationDate: "2024-02-14",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/10.jpg"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t10.jpg"),
      width: 1600,
      height: 1900,
      artist: artists.aprion,
      creationDate: "2024-04-04",
      tags: ["anthro", "avian", "feline"]
  },
  {
      largeURL: require("@/assets/img/sfw/11.gif"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t11.gif"),
      width: 2000,
      height: 1333,
      artist: artists.graylynx,
      creationDate: "2024-06-15",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/12.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t12.jpg"),
      width: 1869,
      height: 2048,
      artist: artists.ruffusbleu,
      creationDate: "2024-08-07",
      tags: ["anthro", "canine"]
  },
  {
      largeURL: require("@/assets/img/sfw/13.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t13.jpg"),
      width: 3600,
      height: 4600,
      artist: artists.kousuracon,
      creationDate: "2024-08-20",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/14.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t14.jpg"),
      width: 3600,
      height: 4600,
      artist: artists.kousuracon,
      creationDate: "2024-08-21",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/15.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t15.jpg"),
      width: 4000,
      height: 4000,
      artist: artists.gedebuk,
      creationDate: "2024-09-04",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/16.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t16.jpg"),
      width: 4000,
      height: 4000,
      artist: artists.gedebuk,
      creationDate: "2024-09-04",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/17.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t17.jpg"),
      width: 4014,
      height: 2864,
      artist: artists.aduran,
      creationDate: "2024-09-27",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/18.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t18.jpg"),
      width: 2560,
      height: 1440,
      artist: artists.skylerie,
      creationDate: "2024-10-03",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/19.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t19.jpg"),
      width: 1248,
      height: 1491,
      artist: artists.skylerie,
      creationDate: "2024-10-09",
      tags: ["anthro", "avian"]
  },
  {
      largeURL: require("@/assets/img/sfw/20.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t20.jpg"),
      width: 1000,
      height: 1000,
      artist: artists.garoline,
      creationDate: "2024-10-30",
      tags: ["feral", "canine"]
  },
  {
      largeURL: require("@/assets/img/sfw/21.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t21.jpg"),
      width: 2500,
      height: 2300,
      artist: artists.lordrex,
      creationDate: "2024-11-26",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/22.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t22.jpg"),
      width: 1090,
      height: 1090,
      artist: artists.kousen,
      creationDate: "2024-12-21",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/23.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t23.jpg"),
      width: 893,
      height: 1181,
      artist: artists.skylerie,
      creationDate: "2025-02-04",
      tags: ["anthro", "feline"]
  },
  {
      largeURL: require("@/assets/img/sfw/24.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/t24.jpg"),
      width: 831,
      height: 831,
      artist: artists.gabrianne,
      creationDate: "2025-05-14",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/067-2025-SFW-Comm-WolfIcon-Neku.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_067-2025-SFW-Comm-WolfIcon-Neku.jpg"),
      width: 1500,
      height: 1500,
      artist: artists.neku,
      creationDate: "2025-06-30",
      tags: ["anthro", "canine"]
  },
  {
      largeURL: require("@/assets/img/sfw/075-2025-SFW-Comm-SketchHeashot-Trioza.jpg"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_075-2025-SFW-Comm-SketchHeashot-Trioza.jpg"),
      width: 894,
      height: 894,
      artist: artists.trioza,
      creationDate: "2025-08-28",
      tags: ["feral", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/076-2025-SFW-Comm-DigiPartnerHD-GabrianneArts.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_076-2025-SFW-Comm-DigiPartnerHD-GabrianneArts.jpg"),
      width: 1980,
      height: 2400,
      artist: artists.gabrianne,
      creationDate: "2025-09-05",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/077-2025-SFW-Comm-FirstCave-Reku.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_077-2025-SFW-Comm-FirstCave-Reku.jpg"),
      width: 5162,
      height: 2160,
      artist: artists.reku,
      creationDate: "2025-09-23",
      tags: ["feral", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/079-2025-SFW-Comm-Flamedramon-J450N.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_079-2025-SFW-Comm-Flamedramon-J450N.jpg"),
      width: 2025,
      height: 3158,
      artist: artists.j450n,
      creationDate: "2025-10-16",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/083-2025-SFW-Comm-IconPixelArt400-Arunkie.gif"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_083-2025-SFW-Comm-IconPixelArt400-Arunkie.gif"),
      width: 436,
      height: 488,
      artist: artists.arunkie,
      creationDate: "2025-10-26",
      tags: ["feral", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/086-2025-SFW-Comm-SharkLimo-Chrinos.jpg"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_086-2025-SFW-Comm-SharkLimo-Chrinos.jpg"),
      width: 3840,
      height: 3840,
      artist: artists.chrinos,
      creationDate: "2025-10-28",
      tags: ["anthro", "fish"]
  },
  {
      largeURL: require("@/assets/img/sfw/088-2025-SFW-Comm-SharkLimoSketch-CheChito.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_088-2025-SFW-Comm-SharkLimoSketch-CheChito.jpg"),
      width: 1203,
      height: 677,
      artist: artists.chechito,
      creationDate: "2025-11-03",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/090-2025-SFW-Comm-Nature-TaranFiddler.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_090-2025-SFW-Comm-Nature-TaranFiddler.jpg"),
      width: 5000,
      height: 4000,
      artist: artists.taranfiddler,
      creationDate: "2025-12-04",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/096-2025-SFW-Comm-Bull-Exal.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_096-2025-SFW-Comm-Bull-Exal.jpg"),
      width: 1568,
      height: 1711,
      artist: artists.exal,
      creationDate: "2025-12-13",
      tags: ["anthro", "bovid"]
  },
  {
      largeURL: require("@/assets/img/sfw/097-2026-SFW-Comm-HyperFeral-Smallleaf.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_097-2026-SFW-Comm-HyperFeral-Smallleaf.jpg"),
      width: 4073,
      height: 3187,
      artist: artists.smallleaf,
      creationDate: "2026-02-07",
      tags: ["feral", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/108-2026-SFW-Comm-DergnRoll-Mleem.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_108-2026-SFW-Comm-DergnRoll-Mleem.jpg"),
      width: 2032,
      height: 1640,
      artist: artists.mleem,
      creationDate: "2026-02-26",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/109-2026-SFW-Comm-Marten-Skylerie.jpg"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_109-2026-SFW-Comm-Marten-Skylerie.jpg"),
      width: 979,
      height: 1246,
      artist: artists.skylerie,
      creationDate: "2026-03-11",
      tags: ["anthro", "rodent"]
  },
  {
      largeURL: require("@/assets/img/sfw/117-2026-SFW-Comm-ForestFullHD-JadeDragoness.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_117-2026-SFW-Comm-ForestFullHD-JadeDragoness.jpg"),
      width: 1920,
      height: 1080,
      artist: artists.jadedragoness,
      creationDate: "2026-05-27",
      tags: ["feral", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/121-2026-SFW-Gift-DinoLimo-Laserpaints.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_121-2026-SFW-Gift-DinoLimo-Laserpaints.jpg"),
      width: 1373,
      height: 2065,
      artist: artists.laser,
      creationDate: "2026-06-09",
      tags: ["anthro", "scalie"]
  },
  {
      largeURL: require("@/assets/img/sfw/129-2026-SFW-Comm-HorseCouch-Laser.png"),
      thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_129-2026-SFW-Comm-HorseCouch-Laser.jpg"),
      width: 2660,
      height: 2204,
      artist: artists.laser,
      creationDate: "2026-07-26",
      tags: ["feral", "equine"]
  },
  {
    largeURL: require("@/assets/img/sfw/130-2026-SFW-Comm-PushUp1-DouglasKim.png"),
    thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_130-2026-SFW-Comm-PushUp1-DouglasKim.jpg"),
    width: 2878,
    height: 2287,
    artist: artists.douglaskim,
    creationDate: "2026-10-08",
    tags: ["anthro", "scalie"]
  },
  {
    largeURL: require("@/assets/img/sfw/131-2026-SFW-Comm-PushUp2-DouglasKim.png"),
    thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_131-2026-SFW-Comm-PushUp2-DouglasKim.jpg"),
    width: 2878,
    height: 2287,
    artist: artists.douglaskim,
    creationDate: "2026-10-08",
    tags: ["anthro", "scalie"]
  },
  {
    largeURL: require("@/assets/img/sfw/136-2026-SFW-Comm-Bear-Skylerie.png"),
    thumbnailURL: require("@/assets/thumbnails/sfw/thumbnail_136-2026-SFW-Comm-Bear-Skylerie.jpg"),
    width: 1489,
    height: 1550,
    artist: artists.skylerie,
    creationDate: "2026-10-29",
    tags: ["anthro", "ursine"]
  },




];